<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>

<form [formGroup]="composeEmail" fxLayout="column" fxLayout.sm="column"
    fxLayout.xs="column">
    <mat-form-field>
        <mat-select placeholder="Select email template"
            formControlName="emailTemplate"
            (ngModelChange)="selectTemplate($event)">
            <mat-option>-- None --</mat-option>
            <mat-option *ngFor="let emailTemplate of isNotSystemTemplateList"
                [value]="emailTemplate">
                {{emailTemplate.emailTemplateName}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="!isAwardDeclineEmail"
       >
        <mat-select placeholder="To" formControlName="toAdd" multiple required>
            <mat-option *ngFor="let toAdd of toAddList" [value]="toAdd">{{toAdd}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="!isAwardDeclineEmail">
        <mat-select placeholder="To (Group)" formControlName="groupEmail"
            multiple>
            <mat-option *ngFor="let groupEmail of groupEmails"
                [value]="groupEmail">{{groupEmail}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-fiel>
        <mat-select placeholder="CC" formControlName="ccAdd" multiple>
            <mat-option *ngFor="let ccAdd of ccAddList" [value]="ccAdd">{{ccAdd}}</mat-option>
        </mat-select>
    </mat-form-fiel>
    <mat-form-field>
        <mat-select placeholder="CC (Group)" formControlName="GroupCCEmail"
            multiple>
            <mat-option *ngFor="let groupCCEmail of groupEmails"
                [value]="groupCCEmail">{{groupCCEmail}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="input-field">
        <input type="text" placeholder="Subject" matInput maxlength="150"
            required formControlName="subject">
    </mat-form-field>

    <div class="text-editor">
        <!-- <app-ngx-editor [config]="editorConfig" required formControlName="body" [spellcheck]="true">
        </app-ngx-editor> -->
        <quill-editor style="min-height: 300px;" required formControlName="body"
            [modules]='editorConfig'
            placeholder='Enter text here...'>
        </quill-editor>
    </div>
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center"
        class="email-button">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-raised-button (click)="onSend()" color="primary"
            [disabled]="composeEmail.invalid">Send</button>
    </div>
</form>